export default [
    {
        path: '/emails',
        name: 'emails',
        component: () =>
            import(/* webpackChunkName: "emails" */ '@/views/emails/Index.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Emails', to: { name: 'emails' }, disable: true },
            ],
            whitelabel: true,
        },
    },
    {
        path: '/emails/create',
        name: 'emails/create',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "emails" */ '@/views/emails/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Emails', to: { name: 'emails' }, disable: false },
                {
                    text: 'Novo',
                    to: { name: 'emails/create' },
                    disable: true,
                },
            ],
            whitelabel: true,
        },
    },
    {
        path: '/emails/edit/:id',
        name: 'emails/edit',
        child: true,
        component: () =>
            import(/* webpackChunkName: "emails" */ '@/views/emails/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                { text: 'Emails', to: { name: 'emails' }, disable: false },
                {
                    text: 'Editar',
                    to: { name: 'emails/edit' },
                    disable: true,
                },
            ],
            whitelabel: true,
        },
        props: true,
    },
]
